import { render, staticRenderFns } from "./DashboardShopsGraph.vue?vue&type=template&id=5f796aa0&"
import script from "./DashboardShopsGraph.vue?vue&type=script&lang=js&"
export * from "./DashboardShopsGraph.vue?vue&type=script&lang=js&"
import style0 from "./DashboardShopsGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
